import type { AxiosResponse } from 'axios';
import axios from 'axios';

interface GoogleAnalyticsUpdateArgs {
  /**
   * The site id for which the user is setting a dimension index.
   */
  siteId: number;

  /**
   * Automatically forward Google Analytics Events into Hotjar.
   */
  tagSessions: boolean;

  /**
   * Tag GA session with Hotjar UserId.
   */
  sendHotjarUserId: boolean;

  /**
   * The user Google Analytics dimension index, only valid for UA.
   */
  dimensionIndex: string;
}

/**
 * Update GA integration settings.
 *
 * @param {GoogleAnalyticsUpdateArgs} args GA integration settings
 */

const update = ({
  siteId,
  tagSessions,
  sendHotjarUserId,
  dimensionIndex,
}: GoogleAnalyticsUpdateArgs): Promise<AxiosResponse<{ success: boolean }>> =>
  axios.post(`/api/v1/sites/${siteId}/integrations/google_analytics`, {
    send_hotjar_id: sendHotjarUserId,
    hjuid_dimension_index: dimensionIndex.length ? dimensionIndex : null,
    tag_sessions: tagSessions,
  });

export const googleAnalyticsApi = {
  update,
};
